import React, { useMemo } from 'react';

function AdminAuthors({ articles }) {
  const authors = useMemo(() => {
    const grouped = new Map();

    articles.forEach((article) => {
      const name = article.author || `${article.source} News Desk`;
      const current = grouped.get(name) || {
        name,
        articles: 0,
        views: 0,
        latest: article.date
      };

      current.articles += 1;
      current.views += article.viewCount || 0;
      grouped.set(name, current);
    });

    return [...grouped.values()].sort((a, b) => b.articles - a.articles);
  }, [articles]);

  return (
    <section className="admin-panel">
      <div className="admin-panel-head">
        <div>
          <span className="admin-overline">CONTRIBUTORS</span>
          <h2>Authors and news desks</h2>
          <p>Contributors detected from published article records.</p>
        </div>
      </div>

      <div className="admin-table-wrap">
        <table>
          <thead>
            <tr>
              <th>Author</th>
              <th>Published stories</th>
              <th>Total views</th>
              <th>Latest publication</th>
            </tr>
          </thead>
          <tbody>
            {authors.map((author) => (
              <tr key={author.name}>
                <td><b>{author.name}</b></td>
                <td>{author.articles}</td>
                <td>{author.views.toLocaleString()}</td>
                <td>{author.latest}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {!authors.length && (
        <p className="admin-empty">
          Authors will appear after the first successful import.
        </p>
      )}
    </section>
  );
}

export default AdminAuthors;